import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      [theme.breakpoints.down('sm')]: {
        height: 120,
      },
      [theme.breakpoints.down('xs')]: {
        height: 80,
      },
      width: '100%',
      height: 120,
      marginLeft: 1,
      marginBottom: 1,
      marginTop: 1,
      borderRadius: 15,
      cursor: 'pointer',
    },
    img: {
      width: '100%',
      height: '100%',
      borderRadius: 5,
    },
  }),
);

export default useStyles;
